import React, {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import SubHeader from "../../components/header/SubHeader";
import Form from "../../components/common/form/Form";
import Button from "../../components/common/button/Button";
import {CreateBank} from "../../store/bank-setting-slice";
import {BankFormSchema} from "../../schema/bankSchema";
import {getBankSettingFormData} from "../../models/bankModel";

const BankAdd = () => {
    const navigator = useNavigate();
    const dispatch = useDispatch();
    const userRole = useSelector((state) => state.auth.selectedRole);
    const {
        createStatus,
        error
    } = useSelector(state => state.bankSetting);

    useEffect(() => {
        if (createStatus === "success") {
            navigator(".."); // Adjust the navigation path as needed
        }
    }, [createStatus, navigator]);

    const formSubmitHandler = (data) => {
        const updatedData = {
            ...data,
            id: userRole.scopeId,
            accountNumber: Number(data.accountNumber),
        }
        dispatch(CreateBank({...userRole, data: updatedData}))
    };

    const formCancelHandler = () => {
        navigator(".."); // Adjust the navigation path as needed
    };

    const schema = BankFormSchema();
    const initialData = getBankSettingFormData();
    return (
        <>
            <SubHeader title="Add Bank">
                <Button to=".." className="btn-sm bg-secondary bg-opacity-50">Back</Button>
            </SubHeader>
            <div className="container p-0 ms-0">
                <div className="row">
                    <div className="col-xl-8">
                        <Form
                            onFormSubmit={formSubmitHandler}
                            onFormCancel={formCancelHandler}
                            schema={schema}
                            inline={false}
                            initialData={initialData}
                            status={createStatus}
                            error={error}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};
export default BankAdd;
